import React, {useContext} from "react";
import {Link} from "react-scroll";
import s from "./mainMenu.module.css"
import { MenuContext } from "../context/DialogState";
import { NavContext } from "../context/NavState";

export const SideMenu = () => {
    const {isMenuOpen,toggleMenu} = useContext(MenuContext);
    const {navigation} = useContext(NavContext);

    return <nav /*open={isMenuOpen} */ className={s.sidemenu} style={isMenuOpen ? {transform: "translateX(0)"}:{}}>
        <React.Fragment>
            {navigation.map((link,i)=>(
                  <Link onClick={() => toggleMenu()} key={i} className={s.sidemenu_item} to={link.to} offset={-65} smooth={true}
                  duration={800}>{link.text}</Link>
            ))}
        </React.Fragment>
    </nav>;
};

